import React, { useDeferredValue, useState } from 'react';
import { Button, Collapse } from "react-bootstrap";
import CustomPagination from '../../components/CustomPagination';
import PageHeader from "../../components/PageHeader";
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetExpenceQuery, useGetExpenceStatisticsQuery, useRemoveExpenceMutation } from '../../redux/services/ExpenceService';
import { deleteConfirmation } from "../../utils";
import Filter from '../PaymentsPage/Filter';
import ExpenseCreateModal from './ExpenseCreateModal';
import ExpenseViewodal from './ViewModal';


const ExpensePage = () => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)
    const [query, setQuery] = useState(null)
    const params = useDeferredValue(query)

    const [removeRequest] = useRemoveExpenceMutation()

    const [open, setOpen] = useState(false);


    const { data: data3, refetch: refetch2 } = useGetExpenceStatisticsQuery(params?.id ? params?.id : 0)
    const { data: data2, isFetching, refetch } = useGetExpenceQuery({ id: params?.id ? params?.id : 0, pagination: `?page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}` })
    const drivers = data2?.response?.data?.data
    const total = data2?.response?.data?.total;
    const statistic = data3?.response?.data



    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    return (
        <>
            <PageHeader name="Expense" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Create Expense
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                refetch()
                                                refetch2()
                                            }}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary  "
                                            onClick={() => setOpen(!open)} // Toggle collapse
                                            aria-controls="collapse-inputs"
                                            aria-expanded={open}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>
                                    <div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_').join(' ')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="w-100">
                                    <Filter setQuery={setQuery} />
                                </div>
                            </Collapse>
                            <div className="card-body">
                                <div class="single-data mt-2">
                                    {statistic && (
                                        <div class="row">
                                            <div class="col-lg-4 col-md-6 col-sm-6 ">
                                                <div class="card border">
                                                    <div class="card-body">
                                                        <div class="d-flex align-items-start">
                                                            <div class="flex-grow-1">
                                                                <p class="mb-0">Total Expense Amount</p><span class="fs-5">${statistic?.total?.amount || 0}</span>
                                                            </div>
                                                            <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-primary-transparent text-primary"><i class="fe  fs-18">$</i></span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6 ">
                                                <div class="card border">
                                                    <div class="card-body">
                                                        <div class="d-flex align-items-start">
                                                            <div class="flex-grow-1">
                                                                <p class="mb-0">Total Expense Monthly Amount</p><span class="fs-5">${statistic?.monthly?.amount || 0}</span>
                                                            </div>
                                                            <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-secondary-transparent text-secondary"><i class="fe fe-package fs-18"></i></span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-6 col-sm-6">
                                                <div class="card border">
                                                    <div class="card-body">
                                                        <div class="d-flex align-items-start">
                                                            <div class="flex-grow-1">
                                                                <p class="mb-0">Total Expense Weekly Amount</p><span class="fs-5">${statistic?.weekly?.amount || 0}</span>
                                                            </div>
                                                            <div class="min-w-fit-content ms-3"><span class="avatar avatar-md br-5 bg-warning-transparent text-warning"><i class="fe fe-user fs-18"></i></span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            name: 'ID',
                                            selector: row => row.id,
                                            sortable: true,
                                            width: '70px',
                                        },
                                        {
                                            selector: row => row?.driver?.full_name,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('driver_name')}
                                                >
                                                    {searchBy == 'driver_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.type,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('type')}
                                                >
                                                    {searchBy == 'type' ? <b className='text-success'>Expense Type</b> : 'Expense Type'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'Expense Amount ($)',
                                            selector: row => row.amount,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Expense Start Date',
                                            selector: row => row.start,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Expense End Date',
                                            selector: row => row.end,
                                            sortable: true,
                                        },

                                        {
                                            name: 'Expense Description',
                                            selector: row => row.description,
                                            sortable: true,
                                        },

                                        {
                                            name: 'Create Date & Time',
                                            selector: row => row.created_at,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">
                                                        <Button
                                                            onClick={() => handleEdit(row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </Button>

                                                        <Button
                                                            onClick={() => handleView(row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-line" />
                                                        </Button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {isShow && (
                <ExpenseCreateModal
                    show={isShow}
                    handleClose={() => {
                        setIsShow(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}

            {isView && (
                <ExpenseViewodal
                    show={isView}
                    handleClose={() => {
                        setIsView(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}
        </>
    );
};

export default ExpensePage;